import { render } from "./PersonCard.vue?vue&type=template&id=d74d3096&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=d74d3096&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74d3096"],['__file',"src/components/PersonCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d74d3096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d74d3096', __exports__)) {
    api.reload('d74d3096', __exports__)
  }
  
  module.hot.accept("./PersonCard.vue?vue&type=template&id=d74d3096&scoped=true", () => {
    api.rerender('d74d3096', render)
  })

}


export default __exports__